/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import { Popup, Icons, Button } from '@techsoftware/happay-widgets';
import { onKeyPress } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import PlaidLink from 'react-plaid-link';
import Shimmer from '@techsoftware/happay-widgets/Shimmer';
// import HelpIcon from '../../assets/images/help.svg';
// import Breadcrumbs from './breadcrumbs';
// import { routes } from '../../constants/routeConfigMap';
import history from '../../utils/history';
import ProductSwitchIcon from '../../assets/images/switch.svg';
// import CardRequest from '../../containers/cardRequestContainer';
import HeaderBreadCrumb from '../headerBreadCrumb';
// import { currencyFormatter } from '../../helpers/genericFormator';
import PaymentIcon from '../../assets/images/IPP_product_logo_small.svg';
import StatusFormatter from '../customComponent/customTable/tableFormat/statusFormatter';
// import Icon from '@techsoftware/happay-widgets/FontIcon';
import BalanceSummaryPopup from '../BalanceSummary';

class GenericHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      cardReqPopUp: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCardReqDialog = this.handleCardReqDialog.bind(this);
  }

  handleClick(event) {
    // event.preventDefault(); // Let's stop this event.
    // event.stopPropagation();
  }

  handleClose(event) {
    const target = event?.target || event?.srcElement;
    const id = target?.id;
    if ((id !== 'userText' && id !== 'userBtn') || event.key === 'Escape') {
      this.setState({ open: false });
    }
  }

  handleClickProfile = () => {
    history.push('/profile');
  };

  componentDidUpdate() {
    const { location: { search = '', pathname } = { search: '' } } = history;

    if (search.includes('requestcard')) {
      history.replace(pathname);
      this.setState({ cardReqPopUp: true });
    }
  }

  drawButtons() {
    return Object.keys(this.props.headerconfig).map((item, i) =>
      this.makeItem(item),
    );
  }

  handleLogout = () => {
    // this.props.logout();
    history.push('/logout');
  };

  returnProfile = (shortName, fullName) => (
    <>
      <div className="padding-20">
        <Grid
          container
          direction="row"
          alignItems="center"
          className="margin-b-10"
        >
          <div className="avatar">
            <span> {shortName}</span>
          </div>
          <div className="alert-message dark margin-l-10">
            {`${fullName.substring(0, 18)} ${
              fullName.length > 20 ? '...' : ''
            }`}
          </div>
        </Grid>
        <div>
          <span
            className="hw-link-button-primary margin-l-30"
            onClick={this.handleClickProfile}
            onKeyDown={event =>
              onKeyPress(event, () => this.handleClickProfile(event))
            }
            tabIndex={0}
          >
            View Profile
            <Icons type="arrowbutton" className="margin-l-10" />
          </span>
        </div>
        <hr />
        <div
          tabIndex={0}
          className="hw-link-button-secondary"
          onClick={this.handleLogout}
          onKeyDown={event => onKeyPress(event, () => this.handleLogout(event))}
        >
          <Icons type="logout" className="margin-r-10" />
          Logout
        </div>
      </div>
    </>
  );

  onChangeUserButton = event => {
    event.stopPropagation();
    if (event.charCode === 13 || !event.charCode) {
      this.setState(prevState => ({ open: !prevState.open }));
    }
  };

  onChangeProductIcon = (event, config) => {
    event.stopPropagation();
    const { onButtonClick } = this.props;
    if (event.charCode === 13 || !event.charCode) {
      onButtonClick(event, config);
    }
  };

  makeItem(type) {
    const { headerconfig, onButtonClick } = this.props;
    const config = headerconfig[type];

    switch (type) {
      case 'userButton':
        return (
          <div id="headerUserButton">
            {config.name ? (
              <div
                id="userBtn"
                tabIndex={0}
                className="avatar hover margin-l-24"
                onClick={this.onChangeUserButton}
                onKeyPress={this.onChangeUserButton}
              >
                <span id="userText">{config.name}</span>
              </div>
            ) : (
              <Shimmer
                width={30}
                type="circle"
                className="margin-t-8 margin-l-24"
              />
            )}
            <Popup
              id="headerUserPopup"
              parentElementId="headerUserButton"
              open={this.state.open}
              onClose={this.handleClose}
              pointerPlacement="top-right"
              variant="scroll"
              popupStyle={{ width: '250px', top: 10, right: -60 }}
            >
              {this.returnProfile(config.name, config.fullName)}
            </Popup>
          </div>
        );
      case 'requestCardButton':
        // return <div><CardRequest config={config} /> </div>;
        return (
          <Button
            type="button"
            text={config.name}
            variant="primary"
            size="medium"
            className="margin-l-24"
            onClick={event => {
              event.stopPropagation();
              // this.props.onButtonClick(event, this.props.config);
              this.setState({ cardReqPopUp: true });
            }}
          />
        );
      case 'productSwitch':
        return (
          <div
            tabIndex={0}
            id="product-switch-icon"
            onKeyPress={event => this.onChangeProductIcon(event, config)}
            className="margin-l-20 focus-visible"
          >
            <img
              src={ProductSwitchIcon}
              alt="product-switch-icon"
              className="pointer"
              onClick={event => this.onChangeProductIcon(event, config)}
            />
          </div>
        );
      case 'crossButton':
        return (
          <Icons
            className="pointer margin-l-24"
            type="cross"
            tabIndex={0}
            interactive
            onClick={event => {
              onButtonClick(event, config);
            }}
          />
        );
      case 'infoButton':
        return (
          <div id={config.key}>
            <Icons
              className="pointer margin-l-24"
              type="support"
              tooltipText="Help"
              tabIndex={0}
              interactive
              onClick={event => {
                onButtonClick(event, config);
              }}
            />
          </div>
        );
      case 'plaidButton':
        return (
          <PlaidLink
            style={{
              width: '90%',
            }}
            clientName="Plaid Client"
            className="btn-small btn-primary"
            env="sandbox"
            product={['auth', 'transactions']}
            publicKey="ac28dc8fbec7915db62025b5661ea7"
            apiVersion="v2"
            onSuccess={token => {
              onButtonClick(token, config);
            }}
          >
            + Bank account
          </PlaidLink>
        );
      case 'limitInfo':
        const { org_limit, user_limit, userInfo = {} } = this.props;
        const { default_currency: currency } = userInfo;
        const isAdmin = userInfo?.has_role;
        if (isAdmin === undefined) return null;

        const overallAvailableLimit = isAdmin
          ? org_limit?.available || 0
          : user_limit?.available || 0;

        const schedulePayment = isAdmin
          ? org_limit?.scheduled_payment || 0
          : user_limit?.scheduled_payment || 0;

        const available = overallAvailableLimit - schedulePayment;

        return (
          <div id={config.key}>
            <div
              className="limitinfo fw-500 font-12 hw-text-body"
              style={{ textAlign: 'right' }}
            >
              Credit Balance
            </div>

            <BalanceSummaryPopup
              id="wallet-limit-popup"
              available={overallAvailableLimit}
              schedule={schedulePayment}
              currency={currency}
              className="status green"
              hideInfo
            />
          </div>
        );
      case 'button':
        return (
          <div id={config.key}>
            <Button
              type="button"
              text={config.name}
              size="medium"
              variant={config.variant || 'primary'}
              className={config.className || 'margin-l-24'}
              onClick={event => {
                event.stopPropagation();
                this.props.onButtonClick(event, config);
              }}
              disabled={config.disable || false}
            />
          </div>
        );
      case 'edit':
        return (
          <div id={config.key}>
            <Icons
              className="pointer margin-l-24"
              type="edit"
              tooltipText="Edit"
              interactive
              onClick={event => {
                event.stopPropagation();
                this.props.onButtonClick(event, config);
              }}
            />
          </div>
        );
      case 'delete':
        return (
          <div id={config.key}>
            <Icons
              className="pointer"
              type="remove"
              tooltipText="Delete"
              interactive
              onClick={event => {
                event.stopPropagation();
                this.props.onButtonClick(event, config);
              }}
            />
          </div>
        );
      default:
        return null;
    }
  }

  handleCardReqDialog(state, evt) {
    this.setState({ cardReqPopUp: state });
  }

  render() {
    const {
      showBreadcrumbs,
      title,
      headerconfig,
      from,
      showStatus,
      data,
    } = this.props;
    const breakPoint =
      from === 'invoice' ? 24 : ['detail', 'vendor'].includes(from) ? 16 : 24;
    const breakPointSM_MD =
      from === 'invoice' ? 24 : ['detail', 'vendor'].includes(from) ? 16 : 24;
    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        className={`genericHeaderContainer ${
          !showBreadcrumbs ? 'header-after-scroll' : ''
        } ${from ? '' : 'padding-lr-50'} `}
      >
        <Grid
          item
          container
          justify="center"
          alignItems="center"
          xs={breakPoint}
          sm={breakPointSM_MD}
          md={breakPointSM_MD}
          xl={breakPoint}
          lg={breakPoint}
          className={from === 'invoice' ? 'padding-lr-70' : ''}
        >
          <Grid container item xs={12} alignItems="center">
            {showBreadcrumbs ? (
              <HeaderBreadCrumb />
            ) : (
              <>
                <img
                  onClick={() => history.push('/dashboard')}
                  className="pos-fixed left-20 pointer"
                  height={32}
                  width={32}
                  src={PaymentIcon}
                />
                <div className="flex-center heading-h2 font-18 fw-500">
                  {title}
                  {showStatus && data && (
                    <div className="margin-l-20">
                      <StatusFormatter data={data} />{' '}
                    </div>
                  )}
                </div>
              </>
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            justify="flex-end"
            alignItems="center"
            className={showBreadcrumbs ? 'rightHeaders slide-bottom' : ''}
          >
            {headerconfig ? this.drawButtons() : null}
          </Grid>
        </Grid>

        {/* <CardRequest
          cardReqPopUp={this.state.cardReqPopUp}
          setPopupState={this.handleCardReqDialog}
        /> */}
      </Grid>
    );
  }
}

export default GenericHeader;

GenericHeader.propTypes = {
  // title: PropTypes.string,
  headerconfig: PropTypes.object,
  onButtonClick: PropTypes.func,
  itemMap: PropTypes.object,
  showBreadcrumbs: PropTypes.bool,
  title: PropTypes.string,
  // location: PropTypes.object,
  // logout: PropTypes.func,
};

GenericHeader.defaultProps = {
  showBreadcrumbs: true,
};
